<template>
    <div id="staff-content" class="px-6">
        <template>
            <div slot="header" class="flex justify-between py-6">
                <h3 class="font-bold">Staff Information</h3>
                <vs-button type="border" color="danger" class="ml-4 gradient gradient-danger no-shadow" @click="popupActive=true">
                    Delete staff
                </vs-button>
                <vs-popup class="holamundo delete-staff-popup" title="Delete Staff" :active.sync="popupActive">
                    <div class="text-center">
                        <h3>Do you want to delete this staff?</h3>
                        <div class="flex flex-wrap justify-center align-center p-6 mt-6">
                        <vs-button class="mr-6 align-center delete-responsive" @click="deleteStaff">Delete</vs-button>
                        <vs-button type="border" color="danger" class="cancel-responsive" @click.stop="closePopup">Cancel</vs-button>
                        </div>
                    </div>
                </vs-popup>
            </div>

            <!-- <VuePerfectScrollbar class="staff-content-scroll-area" :settings="settings"> -->
                <vs-tabs :color="colorx" class="staff-tab-content" style="background: #fff;">
                    <vs-tab @click="colorx = 'primary'" label="Information">
                        <div class="con-tab-ejemplo">
                            <!-- <staff-info :activeStaffData="activeStaffData" @EditStaff="editStaff"></staff-info> -->
                            <staff-info :activeStaffData="activeStaffData" @ChangeStaffSetting="changeStaffSetting" @EditStaff="editStaff" @ChangeStaffStatus="changeStaffStatus" :key="activeStaffData.user_id" :filter="filter" :currentPage="currentPage" :itemsPerPage="itemsPerPage" @EditCommission="editCommission"></staff-info>
                        </div>
                    </vs-tab>
                    <vs-tab @click="colorx = 'primary'" label="Services">
                       <div class="con-tab-ejemplo py-6">
                             <staff-service v-if="serviceData.length != 0" :activeStaffData="activeStaffData" :serviceData="serviceData" :staffServiceData="staffServiceData" @AddStaffService="addStaffService" @DeleteStaffService="deleteStaffService"></staff-service>
                             <div v-if="serviceData.length == 0" class="text-center">No data Available</div>
                        </div>
                    </vs-tab>
                    <vs-tab @click="colorx = 'primary'" label="Working hours">
                        <div class="con-tab-ejemplo py-6">
                            <working-hour :workingHourData="workingHourData" :activeStaffData="activeStaffData" @SaveWorkingHour="saveWorkingHour"></working-hour>
                        </div>
                    </vs-tab>
                </vs-tabs>
            <!-- </VuePerfectScrollbar> -->
        </template>
    </div>
</template>

<script>
    import VuePerfectScrollbar from 'vue-perfect-scrollbar';
    export default {
        name: 'staff-content',
        components: {
            VuePerfectScrollbar,
        },
        props: {
            activeStaffData: {
                type: Object,
                required: true
            },
            serviceData: {
                type: Array,
                required: true
            },
            staffServiceData: {
                type: Array,
                required: true
            },
            workingHourData: {
                type: Object,
                // required: true
            },
            currentPage: {
                type: Number,
                 required: true
            },
            itemsPerPage: {
                type: Number,
                required: true
            },
            filter: {
                type: Number
            }
        },
        data() {
          // console.log(this.activeStaffData)
            // console.log(this.workingHourData)
            return {
                colorx: 'primary',
                settings: {
                    maxScrollbarLength : 60,
                    wheelSpeed         : 0.70,
                },
                popupActive: false,
                // staff_key: 0
                // workingHour: [],
                // workingHourData: {}
            }
        },
        methods: {
            changeStaffSetting(data){
              this.$emit("ChangeStaffSetting", data);
            },
            editStaff(staff) {
                this.$emit('EditStaff', staff);
            },
            deleteStaff() {
                const staff = {
                    id: this.activeStaffData.user_id,
                    page: this.currentPage,
                    "per-page": this.itemsPerPage
                }
                // this.$store.dispatch("staffList/DELETE_STAFF", staff).then((response) => {
                    // this.$store.dispatch("staffList/GET_STAFF_LIST");
                    this.$emit('DeleteStaff',staff);
                // }).catch(error=>console.log(JSON.parse(error)));
                this.closePopup();
            },
            saveWorkingHour(obj) {
              this.$emit('SaveWorkingHour', obj);
            },
            addStaffService(service_id) {
                this.$emit('AddStaffService', service_id);
            },
            deleteStaffService(service_id) {
                this.$emit('DeleteStaffService', service_id);
            },
            closePopup() {
                this.popupActive = false;
            },
            changeStaffStatus(staff_data) {
                this.$emit('ChangeStaffStatus', staff_data);
                // this.staff_key++;
            },
            editCommission() {
                this.$emit('EditCommission');
            }
        },
        // computed: {
        //     workingHourData() {
        //         return this.$store.getters["staffList/workingHours"];
        //     }
        // },
        computed: {
          commissionList() {
            console.log(this.$store.getters["staffList/commissionList"])
            return this.$store.getters["staffList/commissionList"];
          },
          config(){
            return this.$store.getters['auth/config'];
          }
        },
        created() {
          const obj = {
            staff_id : this.activeStaffData.user_id
          }
          if(this.config && this.config.pos_feature == 1) {
            this.$store.dispatch("staffList/LIST_COMMISSION_BY_STAFF", obj)
          }
            // const staff = {
            //     id: this.activeStaffData.user_id
            // }
            // if (this.activeStaffData.user_id){
            //     this.$store.dispatch("staffList/GET_WORKING_HOUR", staff).then((response) => {
            //         console.log(response);
            //         this.workingHourData = response;
            //     })
            // }
        }
    }
</script>

<style lang="scss">
@import "@/assets/scss/custom/staff/_staff.scss";
</style>
